import React from 'react';
import ContactForm from '@/components/ContactForm';
import BasePage from '@/components/BasePage';
import BaseLayout from '@/components/layouts/BaseLayout';
import { Container, UncontrolledCollapse } from 'reactstrap';
import Booking from '@/components/Booking';

// Translation Higher Order Component
import { translate } from 'react-switch-lang';
const Agreements = ({ t }) => {
	return (
		//React.Fragment is used instead of <div> or <> to hide it from source
		<React.Fragment>
			<BaseLayout
				className="cover"
				title={t('navbar.agreements')}
				description={t('agreements.text1')}
				keywords={`${t('SEO.keywords_common')} ${t('SEO.keywords_agreements')}`}
				canonical="/agreements"
			>
				{/* Base Page - Shared component with Container */}
				<BasePage id="agreements-page" className="agreements-page" role="article">
					<Container>
						<article>
							<h1 className="page_text font-weight-bold">{t('navbar.agreements')}</h1>
							<h2 className="page_subtext text-uppercase">{t('agreements.title')}</h2>
							<hr className="vaccination-page_hr" />
							<p>{t('agreements.text7')}</p>
							<p>{t('agreements.text8')}</p>
							<p>{t('agreements.text2')}</p>
							<br />
							<h2 className="page_subtext text-uppercase">{t('agreements.outpatient')}</h2>
							<p>{t('agreements.text1')}</p>
							<p>{t('agreements.text3')}</p>
							<br />
							<h2 className="page_subtext text-uppercase">{t('agreements.group')}</h2>
							<p>{t('agreements.text4')}</p>
							<br />
							<h2 className="page_subtext text-uppercase">{t('agreements.individual')}</h2>
							<p>{t('agreements.text5')}</p>
							<hr className="vaccination-page_hr" />
							<p>
								{t('agreements.telphone')}
								<a
									className="country_links inline style_italic"
									title="Our telephone: +4554558965"
									href="tel:+4554558965"
								>
									<span itemProp="telephone">(+45) 54558965</span>
								</a>
								{t('agreements.email')}
								<span id="toggler" className="country_links inline clickable style_italic">
									&nbsp;klinik@rcscanning.com
								</span>
							</p>
							<UncontrolledCollapse toggler="#toggler">
								<ContactForm />
							</UncontrolledCollapse>
						</article>
						<Booking />
					</Container>
				</BasePage>
			</BaseLayout>
		</React.Fragment>
	);
};
export default translate(Agreements);
